$(document).ready(/\/curriculum-management\/examination-regulation\/\d+\/course\/(\d+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {
    const removalFunction = function(e) {
        $(this).closest('div.element-row').remove();
        counterUpdateFunction();
    };
    const updateSortIndexFunction = function(container) {
        $(container).find("input[name*=sort]").each(function(key, el) {
            $(el).val(key);
        });
    };
    const counterUpdateFunction = function() {
        let sum = 0;
        $(".element-row input[name*=creditPoints]").each(function(i, el) {
            const val = Number.parseFloat($(el).val());
            if (!isNaN(val)) {
                sum += val;
            }
        });
        $(".credit-point-count").text(new Intl.NumberFormat('de-DE', {minimumFractionDigits: 1}).format(sum));
        sum = 0;
        $(".element-row input[name*=workload]").each(function(i, el) {
            const val = Number.parseFloat($(el).val());
            if (!isNaN(val)) {
                sum += val;
            }
        });
        $(".workload-count").text(new Intl.NumberFormat('de-DE').format(sum));
        sum = 0;
        $(".element-row input[name*=percentage]").each(function(i, el) {
            const val = Number.parseFloat($(el).val());
            if (!isNaN(val)) {
                sum += val;
            }
        });
        $(".percentage-count").text(new Intl.NumberFormat('de-DE').format(sum));
    }
    $(".btn-add-row").click(function (e) {
        const container = $(this).closest("div.card").find(".element-row-container");
        const currentCount = container.find(".element-row").length;
        let template = container.data('template');
        template = template.replace(/__index__/g, currentCount);
        container.append(template);
        container.find(".btn-remove-row:last").click(removalFunction);
        container.find(".element-row:last input[name*=sort]").val(currentCount);
        container.find(".element-row:last input").change(counterUpdateFunction);
    });
    $(".element-row-container .btn-remove-row").click(removalFunction);
    $(".element-row-container input").change(counterUpdateFunction);
    counterUpdateFunction();
    new Sortable($(".element-row-container").get(0), {
        handle: ".draggable",
        onEnd: function(evt) {
            updateSortIndexFunction(evt.target);
        },
    });
    updateSortIndexFunction();
});